import { mockNetworks } from "../network/getmetadata";

const mockUsers = {
  "Lonely Pilgrim": 1,
  "Super Admin": 2,
  "Fred Kiddo": 3,
  "Nelson Muntz": 4,
  "No Phone": 5,
  "No Phone2": 6,
  "Super Duper": 7,
  "No TaxID with phone": 8,
  "Lonely Pilgrim 2": 9,
  "Note Sender": 10,
  "Member Adder": 11,
  "Settings Admin": 12,
  "Security Admin": 13,
  "Billing Admin": 14,
  "Library Admin": 15,
  "Unolytics Admin": 16,
  "SuperUnolytics Admin": 17,
  "Groups Admin": 18,
  "GivingReadOnly Admin": 19,
  "AddGiftsOnly Admin": 20,
  "MMG Admin": 21,
  "ReportBuilder Admin": 22,
  "PrayerRequest Admin": 23,
  "FamilyRegistration Admin": 24,
  "DatabaseSetup Admin": 25,
  "ProfileFields Admin": 26,
  "HouseholdDatabase Admin": 27,
  "ParishInsights Admin": 28,
  "Subnetworks Admin": 29,
  "Signups Admin": 30,
  "Social&Sharing Admin": 31,
  "ContactSettings Admin": 32,
  "HealthReport Admin": 33,
  "Campaigns Admin": 34,
  "TTJ Admin": 35,
  "HomePage Admin": 36,
  "RESetup Admin": 38,
  "No First Name": 37,
  "Sacrament Editor": 39,
  "OnlineGiving Admin": 40,
  "ChangeLog Admin": 41,
  "DuplicateFinder Admin": 42,
  "DataCleanup Admin": 43,
  "Having Trouble": 401,
  "Not Allowed": 403,
  "Mike OneHOH": 14000,
  "Carol OneHOH": 14001,
  "Greg OneHOH": 14002,
  "Mike Brady": 1000,
  "Carol Brady": 1001,
  "Greg Brady": 1002,
  "Caleb Hugo": 1008,
  "Two Wallets": 1009,
  "Link Visitor": 1010,
  "Jane Doe": 123,
  "Nameless HOH": 1100,
  "Prince Caspian King": 29369298,
};

const mockUserDataRes = (networkId, data, verb, userID) => {
  if (networkId === mockNetworks["Logged Out"]) {
    return { success: true, authorized: false, language: "es" };
  }
  switch (verb) {
    case "get":
      switch (userID) {
        case 1:
        case "Member Adder": {
          return {
            success: true,
            userID: 1,
            fname: "Lonely",
            lname: "Pilgrim",
            emailInfo: {
              email: "lonely@pilgrim.net",
              isVerified: true,
            },
            phoneInfo: {
              phone: "",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            language: "en",
          };
        }
        case 2:
          return {
            success: true,
            userID: 2,
            fname: "Super",
            lname: "Admin",
            emailInfo: {
              email: "superadmin@testnet.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15557079110",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: true,
            isBillingAdmin: false,
            isGroupAdmin: true,
            isComposer: true,
            canInputGiving: true,
            language: "en",
          };
        case 3:
          return {
            success: true,
            userID: 3,
            fname: "Fred",
            lname: "Kiddo",
            emailInfo: {
              email: "fredKiddo@kidmail.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15557079199",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            language: "en",
          };
        case 4:
          return {
            success: true,
            userID: 4,
            fname: "Nelson",
            lname: "Muntz",
            emailInfo: {
              email: "nelson@haha.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15177079199",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            language: "en",
          };
        case 5:
          return {
            success: true,
            userID: 5,
            fname: "NoPhone",
            lname: "Home",
            emailInfo: {
              email: "nophone@home.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "",
              isMobile: false,
              isVerified: false,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            language: "en",
          };
        case mockUsers["No Phone2"]:
          return {
            success: true,
            userID: 6,
            fname: "NoPhone2",
            lname: "Home2",
            emailInfo: {
              email: "nophone2@home.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "",
              isMobile: false,
              isVerified: false,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            language: "en",
          };
        case 401: {
          return { success: true, authorized: false };
        }
        case mockUsers["Not Allowed"]:
          return { success: true, authorized: false, language: "es" };
        case mockUsers["Lonely Pilgrim 2"]:
          return { success: true, authorized: false, language: "es" };
        case mockUsers["Note Sender"]:
          return {
            success: true,
            userID: 6,
            fname: "note",
            lname: "sender",
            emailInfo: {
              email: "noteSender@home.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15177079199",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: true,
            language: "en",
          };
        case mockUsers["Groups Admin"]:
          return {
            success: true,
            userID: 18,
            fname: "Groups",
            lname: "Admin",
            emailInfo: {
              email: "groupsadmin@testnet.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15557079112",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: true,
            isComposer: false,
            language: "en",
          };
        case mockUsers["No First Name"]:
          return {
            success: true,
            userID: 37,
            fname: "",
            lname: "NoName",
            emailInfo: {
              email: "nofirstname@test.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15557079111",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: true,
            isGroupAdmin: true,
            isComposer: true,
            language: "en",
          };
        case mockUsers["Sacrament Editor"]:
          return {
            success: true,
            userID: 39,
            fname: "Sally",
            lname: "Sacrament",
            emailInfo: {
              email: "sacramenteditor@test.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15557079999",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            hasAnyElevatedPermissions: true,
            canEditSacraments: true,
            language: "en",
          };
        case mockUsers["GivingReadOnly Admin"]:
          return {
            success: true,
            userID,
            fname: "GivingReadOnly",
            lname: "Admin",
            emailInfo: {
              email: "givingreadonly@testnet.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15557079113",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: false,
            isBillingAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            canInputGiving: false,
            language: "en",
          };
        case mockUsers["OnlineGiving Admin"]:
          return {
            success: true,
            userID,
            fname: "OnlineGiving",
            lname: "Admin",
            emailInfo: {
              email: "onlinegiving@testnet.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15557079114",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: false,
            isSuperAdmin: true,
            isBillingAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            canInputGiving: true,
            language: "en",
          };
        // A donor with two saved payment methods (give/getsavedpaymentmethods.js)
        case mockUsers["Two Wallets"]:
          return {
            success: true,
            userID: mockUsers["Two Wallets"],
            fname: "Marge",
            lname: "Simpson",
            emailInfo: { email: "marge@springfield.com", isVerified: true },
            isSuperAdmin: false,
            language: "en",
          };
        // Recognized from a link, never signed in: a half session
        case mockUsers["Link Visitor"]:
          return {
            success: true,
            userID: mockUsers["Link Visitor"],
            authorized: false,
            fname: "Homer",
            lname: "Simpson",
            language: "en",
          };
        case mockUsers["Mike Brady"]:
          return {
            success: true,
            userID: mockUsers["Mike Brady"],
            fname: "Mike",
            lname: "Brady",
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            language: "en",
          };
        case mockUsers["Jane Doe"]:
          return {
            success: true,
            userID: mockUsers["Jane Doe"],
            fname: "Jane",
            lname: "Doe",
            isSuperDuper: false,
            isSuperAdmin: false,
            isGroupAdmin: false,
            isComposer: false,
            language: "en",
          };
        case 7:
        default:
          return {
            success: true,
            userID: 2,
            fname: "Super",
            lname: "Duper",
            emailInfo: {
              email: "superduper@flocknote.com",
              isVerified: true,
            },
            phoneInfo: {
              phone: "+15557079110",
              isMobile: true,
              isVerified: true,
            },
            isSuperDuper: true,
            isSuperAdmin: true,
            isBillingAdmin: true,
            isGroupAdmin: true,
            isComposer: true,
            canEditHousehold: true,
            canInputGiving: true,
            language: "en",
          };
      }
    default:
      return { success: true, language: "en" };
  }
};

/**
 * Is the asking user a Super Duper, for the mock worlds that answer differently
 * to one? Only the id named Super Duper counts. The `default` case above hands
 * her record back for any id it doesn't know, and a world keyed off THAT would
 * make every test that never set a user a Super Duper's view.
 */
const isSuperDuperViewer = (userID) => userID === mockUsers["Super Duper"];

export { isSuperDuperViewer, mockUsers };
export default mockUserDataRes;
